import React from 'react';
import { connect } from 'react-redux';
import Notification from '../Notification/Notification';

function NotificationList(props) {
  return (
    <section className="notification-list" style={{ position: 'fixed', right: '10px', top: '5.5rem', zIndex: 40 }}>
      {props.errors.map((notification, i) => (<Notification message={notification.message} type={notification.type} index={i} key={`notification_${i}`}/> ) )  }
    </section>
  );
}

function mapStateToProps(state) {
  return {
    errors: state.errors
  }
}

export default connect(mapStateToProps)(NotificationList);


// WEBPACK FOOTER //
// ./src/components/NotificationList/NotificationList.js